import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';

export default {
    i18next: {
        ns: 'md-blog-list'
    },
    data: function() {
        return {};
    },
    methods: {
        getLimitLengthText(text) {
            return text.length > 15 ? text.substring(0, 15) + '...' : text;
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "detailOpenStyle": store => store.page?.blogDetailOpenStyle || '_self'
        }),
        sysTitle() {
            let count = this.count || this.list.length;
            return count === 0
                ? this.$t('md-blog-list.nothingFoundFor', {
                    keywords: this.getLimitLengthText(this.title)
                })
                : this.$t('md-blog-list.resultFor', {
                    count,
                    keywords: this.getLimitLengthText(this.title)
                });
        }
    }
};
